import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUserInfo } from "services/apiService";

export const fetchCurrentUserInfo = createAsyncThunk(
  "fetchCurrentUserInfo",
  async (currentUser) => {
    try {
      const getUserInfoRes = await getUserInfo(currentUser);
      // console.log("here1", getFeedRes);

      if (getUserInfoRes.status === 200) {
        return getUserInfoRes.data;
      }
    } catch (error) {
      console.log("fetchCurrentUserInfoError", error);
    }
  }
);

const initialState = {
  userAppInfo: null,
  isLoadingInfo: true,
};

const userInfoSlice = createSlice({
  name: "userInfo",
  initialState: initialState,
  reducers: {
    getUserAppInfo(state, action) {
      state.userAppInfo = action.payload;
      state.isLoadingInfo = false;
    },
    deleteUserAppInfo(state, action) {
      state.userAppInfo = action.payload;
      state.isLoadingInfo = true;
    },
    userAppInfoReducerReset() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentUserInfo.pending, (state) => {
        state.isLoadingInfo = true;
      })
      .addCase(fetchCurrentUserInfo.fulfilled, (state, action) => {
        state.userAppInfo = action.payload;
        state.isLoadingInfo = false;
      });
  },
});

export const { getUserAppInfo, deleteUserAppInfo, userAppInfoReducerReset } =
  userInfoSlice.actions;
export default userInfoSlice.reducer;
